import { AssetsInvalidRecord } from './assets-invalid-record';

export class AssetsImportResponse {
  constructor(
    public imported = 0,
    public invalid: AssetsInvalidRecord[] = [],
    public unrecoverable = 0,
    public importComplete = false
  ) {}
}
